import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import FormRender from "v4/components/form/FormRender/FormRender";
import FormRest from "v4/components/form/FormRender/components/FormRest/FormRest";
import FormSubmitButton from "v4/components/form/FormRender/components/FormSubmitButton/FormSubmitButton";
import useA11YPopup from "v4/features/front/a11y/hooks/useA11yPopup";

export default function A11yPopup({closePopup}) {
    const {t} = usePolTranslation();
    const {a11yForm, onSubmit} = useA11YPopup(closePopup);

    return (
        <div>
            <FormRender form={a11yForm} onSubmit={onSubmit}>
                <FormRest/>

                <div className="d-flex justify-content-end">
                    <FormSubmitButton>
                        {t('enregistrer')}
                    </FormSubmitButton>
                </div>
            </FormRender>
        </div>
    )
}
